module.exports = __webpack_public_path__ + "static/media/home-new.589ffbc8.mp4";